import type { AdminUser } from "../../shared/admin-auth";

export function customerFacingName(user: Pick<AdminUser, "email" | "name">, savedName: string | null): string {
  if (savedName !== null) return savedName;
  return user.email.toLowerCase() === "info@furniturenlighting.com.au" ? "Tina" : user.name;
}
